<script>
  import {
    clearState,
    navSearchQuery,
    user,
    isAdmin,
    business,
    orders,
    pageClicked,
    newOrdersCount,
    userDetails,
    cart,
    myOrder,
    OS,
    isWebOnMobile,
    forwardToApp,
  } from "../stores.js";
  import { isRtl, isObjectEmpty } from "../utils.js";
  import { location, push, pop } from "svelte-spa-router";
  import * as AuthService from "../dal/auth-dal";

  import { createEventDispatcher } from "svelte";
  const dispatch = createEventDispatcher();

  import CartIcon from "./CartIcon.svelte";
  import FaAngleLeft from "svelte-icons/fa/FaAngleLeft.svelte";
  import MdPhoneAndroid from "svelte-icons/md/MdPhoneAndroid.svelte";
  import FaSignOutAlt from "svelte-icons/fa/FaSignOutAlt.svelte";
  import FaSync from "svelte-icons/fa/FaSync.svelte";
  import FaReceipt from "svelte-icons/fa/FaReceipt.svelte";
  import FaStar from "svelte-icons/fa/FaStar.svelte";
  import LogoIcon from "./icons/LogoIcon.svelte";
  import FaUserAlt from "svelte-icons/fa/FaUserAlt.svelte";
  import { gotoApp } from "../utils.js";

  let navDiv;

  let navVisible = true;

  let input;

  let menuOpen = false;

  $: {
    if (input) {
      input.style.direction = isRtl($navSearchQuery) ? "rtl" : "ltr";
    }
  }

  export function hide() {
    if (navVisible) {
      navVisible = false;
      navDiv.style.marginTop = "-100px";
    }
  }

  export function show() {
    if (!navVisible) {
      navVisible = true;
      navDiv.style.marginTop = "0";
    }
  }

  function hideMenu() {
    menuOpen = false;
  }

  function showMenu(e) {
    menuOpen = !menuOpen;
  }

  // function resetState() {
  //   // deleteAllOrders();
  //   // return;
  //   clearState();
  //   setTimeout(function () {
  //     window.location.reload();
  //   });
  // }

</script>

<svelte:body on:click={hideMenu} />

<nav bind:this={navDiv}>
  {#if window.environment === 'staging'}
    <div class="isStaging" />
  {/if}
  <div
    class="arrowBtn"
    on:click={() => {
      $pageClicked = true;
      pop();
    }}
  >
    <FaAngleLeft />
  </div>
  <div
    class="logo"
    on:click={() => {
      push('/');
    }}
  >
    <LogoIcon />
  </div>

  {#if $cart?.details?.code || $myOrder}
    <div class="cartIcon" style={$user ? 'right:80px' : 'right:100px'}>
      <CartIcon showAnimation={false} />
    </div>
  {/if}
  <div
    class="login"
    on:click|stopPropagation={() => {
      if ($user) {
        showMenu();
      } else {
        push($location + '?showAuth=true');
      }
    }}
  >
    {#if $isAdmin && $newOrdersCount}
      <div class="newOrdersCount">{$newOrdersCount}</div>
    {/if}
    {#if $user}
      <div class="userIcon">
        <FaUserAlt />
      </div>
      <div class="arrow down" />
    {:else}<span> התחברות </span>{/if}
  </div>
  {#if menuOpen}
    <div class="menu">
      {#if $newOrdersCount}
        <div
          class="menuItem logout"
          on:click={() => {
            $pageClicked = true;
            push(`/admin/${$business.code}`);
          }}
        >
          <span class="menuItemIcon">
            <FaReceipt />
          </span>
          {$newOrdersCount}
          הזמנות חדשות
        </div>
      {/if}
      <div class="menuItem logout" on:click={AuthService.logout}>
        <span class="menuItemIcon">
          <FaSignOutAlt />
        </span>
        יציאה
      </div>
      <div
        class="menuItem"
        on:click={() => {
          if (window.cordova) window.location.reload();
          else window.location.assign('/');
        }}
      >
        <span class="menuItemIcon">
          <FaSync />
        </span>
        רענון
      </div>
      {#if $isWebOnMobile && $forwardToApp.includes($OS)}
        <div class="menuItem" on:click={gotoApp}>
          <span class="menuItemIcon">
            <MdPhoneAndroid />
          </span>
          פתיחה באפליקציה
        </div>
      {/if}
      {#if $user && $userDetails?.loyaltyCards && !isObjectEmpty($userDetails.loyaltyCards)}
        <div
          class="menuItem"
          on:click={() => {
            push(`/LoyaltyCards`);
          }}
        >
          <span class="menuItemIcon">
            <FaStar />
          </span>
          הכרטיסיות שלי
        </div>
      {/if}
      <!-- <div
        class="menuItem "
        on:click={() => {
          resetState();
        }}
      >
        <span class="menuItemIcon">
          <MdSettingsBackupRestore />
        </span>
        איפוס הגדרות
      </div> -->
    </div>
  {/if}
</nav>

<style>
  .userIcon {
    width: 20px;
  }

  .isStaging {
    position: absolute;
    width: 100%;
    height: 100%;
    background: url(../images/staging_stamp.png);
    background-size: 65px;
    opacity: 0.5;
    pointer-events: none;
  }
  .newOrdersCount {
    position: absolute;
    background: var(--red1);
    width: 22px;
    height: 22px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 100px;
    right: -10px;
    top: -8px;
    z-index: 1;
    font-size: 12px;
  }

  /* .nav-staging {
    background: rgb(255, 141, 0);
  } */

  nav {
    background: var(--blue1);
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-grow: 0;
    border-bottom: 1px solid #00000014;
    box-shadow: 0px 1px 5px #00000047;
    z-index: 9;
    position: relative;
    width: 100%;
    height: var(--nav-bar-height);
    z-index: 9999;
    user-select: none;
    transition: margin-top 0.3s ease-out;
  }

  .logo {
    display: inline-block;
    padding: 10px;
    box-sizing: border-box;
    margin-left: auto;
    margin-right: auto;
    cursor: pointer;
    height: 100%;
    display: inline-flex;
    min-width: 60px;
    color: white;
  }

  .arrowBtn {
    position: absolute;
    left: 5px;
    width: 40px;
    height: 40px;
    background: transparent;
    color: white;
    display: flex;
    align-items: center;
    cursor: pointer;
  }
  .login {
    position: absolute;
    right: 0;
    border: 2px solid white;
    padding: 10px;
    border-radius: 30px;
    color: white;
    font-size: 17px;
    font-family: "Rubik";
    font-weight: 500;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 10px;
    user-select: none;
    min-width: 60px;
    white-space: nowrap;
    cursor: pointer;
    height: 44px;
    box-sizing: border-box;
  }

  .menu {
    position: absolute;
    top: 70px;
    right: 17px;
    border-radius: 10px;
    box-shadow: 0 10px 10px -10px;
    overflow: hidden;
  }

  .menuItem {
    background: white;
    color: #a5a5a5;
    padding: 18px;
    width: 100%;
    border-bottom: 1px solid #8c8c8c3d;
    position: relative;
    font-size: 15px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    direction: rtl;
    cursor: pointer;
    padding-left: 50px;
  }

  .menuItem:last-child {
    border-bottom: none;
  }

  .menuItem:hover {
    background: var(--blue1);
    color: white;
  }

  .menuItem:hover > .menuItemIcon {
    background: var(--blue1);
    color: white;
  }

  .menuItemIcon {
    width: 30px;
    height: 24px;
    margin-left: 10px;
    color: #7ed0ff;
  }

  .arrow {
    margin: 5px;
    border-radius: 3px;
    border: solid #ffffff;
    border-width: 0 6px 6px 0;
    display: inline-block;
    padding: 3px;
    transform: rotate(45deg);
  }

  .cartIcon {
    margin-right: 10px;
    min-width: 40px;
    cursor: pointer;
    position: absolute;
  }

</style>
